// src/components/card/CardBadge.js
import React from 'react';
import { Chip } from '@mui/material';

const CardBadge = ({ label, ...props }) => (
  <Chip 
    label={label} 
    size="small"
    sx={{ 
      position: 'absolute',
      top: 12,
      left: 12,
      fontWeight: 600,
      backgroundColor: (theme) => theme.palette.secondaryContainer,
      color: (theme) => theme.palette.onSecondaryContainer,
      border: 'none',
      '&:hover': {
        backgroundColor: (theme) => theme.palette.secondaryContainer, // override default chip hover behavior
        opacity: 0.9,
      },
      ...props.sx
    }}
    {...props}
  />
);

export default CardBadge;